import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const navigate = useNavigate();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [loginData, setLoginData] = useState({
    email: '',
    password: ''
  });
  const [showMaintenanceAlert, setShowMaintenanceAlert] = useState(false);

  const handleLoginClick = () => {
    setShowLoginModal(true);
  };

  const handleCloseModal = () => {
    setShowLoginModal(false);
    setLoginData({ email: '', password: '' });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLoginData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleLoginSubmit = (e) => {
    e.preventDefault();
    // Giriş yapma simülasyonu
    setShowLoginModal(false);
    setShowMaintenanceAlert(true);
    
    // 5 saniye sonra uyarıyı kapat
    setTimeout(() => {
      setShowMaintenanceAlert(false);
    }, 5000);
  };

  const handleNavClick = (path) => {
    // Sayfa geçişi için navigate kullan
    navigate(path);
    // Mobil menüyü kapat
    setShowMobileMenu(false);
  };

  const toggleMobileMenu = () => {
    setShowMobileMenu(!showMobileMenu);
  };

  return (
    <>
      <header className="header">
        <div className="container">
          <div className="header-content">
            <div className="logo">
              <button onClick={() => handleNavClick('/')} className="logo-button">
                <img src="/assets/logo-color.svg" alt="Randevu345" className="logo-img" />
              </button>
            </div>
            {/* Desktop Navigation */}
            <nav className="nav desktop-nav">
              <button onClick={() => handleNavClick('/features')} className="nav-link nav-button">
                Özellikler
              </button>
              <button onClick={() => handleNavClick('/pricing')} className="nav-link nav-button">
                Fiyatlar
              </button>
              <button onClick={() => handleNavClick('/contact')} className="nav-link nav-button">
                İletişim
              </button>
              <button onClick={handleLoginClick} className="login-btn">
                Giriş Yap
              </button>
            </nav>

            {/* Mobile Menu Button */}
            <button className="mobile-menu-btn" onClick={toggleMobileMenu}>
              <span className={`hamburger ${showMobileMenu ? 'active' : ''}`}>
                <span></span>
                <span></span>
                <span></span>
              </span>
            </button>
          </div>
        </div>

        {/* Mobile Navigation Menu */}
        <div className={`mobile-nav ${showMobileMenu ? 'active' : ''}`}>
          <div className="mobile-nav-content">
            <button onClick={() => handleNavClick('/features')} className="mobile-nav-link">
              Özellikler
            </button>
            <button onClick={() => handleNavClick('/pricing')} className="mobile-nav-link">
              Fiyatlar
            </button>
            <button onClick={() => handleNavClick('/contact')} className="mobile-nav-link">
              İletişim
            </button>
            <button onClick={handleLoginClick} className="mobile-login-btn">
              Giriş Yap
            </button>
          </div>
        </div>
      </header>

      {/* Login Modal */}
      {showLoginModal && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="login-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2 className="modal-title">Giriş Yap</h2>
              <button className="modal-close" onClick={handleCloseModal}>
                ×
              </button>
            </div>
            
            <form className="login-form" onSubmit={handleLoginSubmit}>
              <div className="form-group">
                <label htmlFor="email" className="form-label">E-posta</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={loginData.email}
                  onChange={handleInputChange}
                  className="form-input"
                  placeholder="ornek@email.com"
                  required
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="password" className="form-label">Şifre</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={loginData.password}
                  onChange={handleInputChange}
                  className="form-input"
                  placeholder="Şifrenizi girin"
                  required
                />
              </div>
              
              <button type="submit" className="login-submit-btn">
                Giriş Yap
              </button>
              
              <div className="login-footer">
                <a href="#forgot" className="forgot-link">Şifremi Unuttum</a>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Maintenance Alert */}
      {showMaintenanceAlert && (
        <div className="maintenance-alert">
          <div className="alert-content">
            <div className="alert-icon">⚠️</div>
            <div className="alert-text">
              <h3>Teknik Bakım</h3>
              <p>Sistem şu anda bakım modunda. Lütfen daha sonra tekrar deneyin veya mobil uygulamadan giriş yapın.</p>
            </div>
            <button 
              className="alert-close" 
              onClick={() => setShowMaintenanceAlert(false)}
            >
              ×
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Header; 